




















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Illustration extends Vue {
    @Prop({ default: '' }) public label!: string;
    @Prop() public src!: any;
    @Prop({ default: 315 }) public maxWidth!: string;
    @Prop({ default: '80%' }) public width!: string;
}
